// Germany
export const locale = {
  admin_login: "Admin Login",
  login: "Login",
  email: "Email",
  password: "Passwort",
  you_are_not_admin: "Du bist kein Admin!",
  dashboard: "Dashboard",
  user: "User",
  organizer: "Veranstalter",
  single_user: "User",
  influencer: "Influencer",
  unapproved: "Nicht genehmigt",
  unapproved_organizer: "Veranstalteranfragen",
  event: "Events",
  post: "Post",
  transaction: "Transaktionen",
  refund: "Rückerstattungen",
  refund_fee: "Rückerstattungsgebühr",
  withdraw: "Umsatzanforderrungen",
  report: "Bericht",
  reported_user: "Gemeldeter Benutzer",
  reported_post: "Gemeldeter Post",
  reported_event: "Gemeldetes Event",
  system: "System",
  change_password: "Passwort ändern",
  send_message_to_users: "Sende eine Nachricht an Benutzer",
  logout: "Ausloggen",
  confirm_logout: "Möchtest du dich ausloggen?",
  deleted: "gelöscht",
  sale: "Verkauft",
  gross_sale: "Bruttoverkauf",
  net_sale: "Nettoverkauf",
  refunded: "Rückerstattet",
  please_wait: "Bitte warten ...",
  online: "Online",
  approve: "Genehmigen",
  decline: "Ablehnen",
  no_data_found: "Keine Daten gefunden!",
  confirm_approve_organizer:
    "Sind Sie sicher diesen Benutzer als Veranstalter zu genehmigen?",
  confirm_approve_single_user:
    "Sind Sie sicher diesen Benutzer als User zu genehmigen?",
  success: "Erfolgreich",
  ticket_price: "Ticketpreis",
  tax_price: "Umsatzsteuer",
  service_charge: "Bearbeitungsgebühr",
  total_price: "Gesamtpreis",
  tickets: "Tickets",
  paid: "Bezahlt",
  requested: "Angefordert",
  total_balance: "Umsatz allgemein",
  not_paid: "Nicht bezahlt",
  already_paid: "Bereits bezahlt",
  pending: "Ausstehend",
  refund_now: "Jetzt rückerstatten",
  remain_balance: "Aktueller Kontostand",
  withdraw_amount: "Abgehobender Betrag",
  status: "Status",
  payment_done: "Zahlung tätigen",
  confirm_withdraw_done: "Sind Sie sicher die Auszahlung beantragt zu haben?",
  confirm_delete_report: "Sind Sie sicher den Bericht zu löschen?",
  current_password: "Aktuelles Passwort",
  new_password: "Neues Passwort",
  confirm_password: "Passwort bestätigen",
  modify: "Ändern",
  password_does_not_match: "Passwort stimmt nicht überein!",
  admin_password_changed_login_again:
    "Das Admin Passwort wurde erfolgreich geändert.",
  current_password_incorrect: "Das aktuelle Passwort ist nicht richtig.",
  title: "Titel",
  message: "Nachricht",
  send: "Senden",
  confirm_send_message:
    "Sind Sie sicher diese Nachricht an alle Benutzer zu schicken?",
  confirm_delete_message: "Sind Sie sicher diese Nachricht löschen zu wollen?",
  report_type_1: "Spam",
  report_type_2: "Gewalt",
  report_type_3: "Nacktheit",
  report_type_4: "Hasspredigen",
  report_type_5: "Terror",
  report_type_6: "Nicht zugelassene Werbung",
  select_month: "Wähle einen Monat",
  select_date_range: "Datumsbereich auswählen",
  // 2023-02-23 16:35
  blocked: "Blockierter",
  block: "Blockieren",
  unblock: "Entblockieren",
  reason: "Begründung",
  confirm_block_user:
    "Sobald dieser Benutzer blockiert ist, kann dieser Benutzer nichts mehr tun! Möchten Sie diesen Benutzer wirklich blockieren?",
  confirm_unblock_user: "Möchten Sie diesen Benutzer wirklich entsperren?",
  confirm_delete_: "Are you sure you want to delete this {0}?",
  // 2023-03-30 14:36
  story: "Story",
  // 2023-11-28
  add_coupon: "Gutschein hinzufügen",
  coupon_code: "Rabattcode",
  percent: "Prozent",
  total_quantity: "Gesamtmenge",
  used_quantity: "Verbrauchte Menge",
  confirm: "Bestätigen",
  edit: "Bearbeiten",
  delete: "Löschen",
  // 2024-04-29
  clear: "Klar",
  cancel: "Abbrechen",
  select_influencer: "Influencer auswählen",
  discount: "Rabatt",
  total_discount: "Rabatte insgesamt",
  sales_total: "Umsatz insgesagt",
  sales_volume_organizer: "Umsatz Veranstalter",
  billing_document: "Rechnung",
  // 2025-08-30
  highlight: "Highlight",
  set_highlight: "Hervorheben",
  remove_highlight: "Nicht mehr hervorheben",
  alarm_list: "Alarm Liste",
  created_at: "Erstellt am",
  export: "Exportieren",
  export_buyers: "Emailadressen downloaden",
  change_service_fee: "Servicegebühr ändern",
  save: "Speichern",
  service_fee: "Servicegebühr",
  service_fee_percent: "Servicegebühr Prozent",
  no_user_selected: "Kein Benutzer ausgewählt",
  invalid_service_fee: "Ungültige Servicegebühr",
  invalid_service_tax: "Ungültige Mehrwertsteuer",
  date_range: "Datumsbereich",
  details: "Details",
  all: "Alle",
  pdf_generated_successfully: "PDF erfolgreich erstellt",
};
